import styled, { css } from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
/**
 * Adds some extra descriptive content to an input, commonly used underneath the label or input
 */
export const InputDescription = styled.div `
  font-size: ${pxToRems(12)};
  line-height: ${pxToRems(16)};

  ${({ status, theme }) => status === 'error' &&
    css `
      color: ${theme.ColorStatusAttention500};
    `}
`;
//# sourceMappingURL=input-description.js.map